import { z } from 'zod';
import { isoDateTimeSchema, optional } from './common';

export const tipoImportSchema = z.enum(['CAPACIDADE', 'CALENDARIO', 'PROGRAMACAO']);
export type TipoImport = z.infer<typeof tipoImportSchema>;

/** 1 Pendente · 2 Validado · 3 Erro · 4 Aplicado (es-pcp-import.situacao) */
export const situacaoLinhaImportSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);

export const linhaImportSchema = z.object({
  'num-linha': z.number().int().positive(),
  conteudo: z.string(),
  situacao: situacaoLinhaImportSchema,
  'msg-erro': optional(z.string()),
});
export type LinhaImport = z.infer<typeof linhaImportSchema>;

export const loteImportSchema = z.object({
  'nr-import': z.number().int(),
  'tipo-import': tipoImportSchema,
  'nome-arquivo': z.string(),
  'nr-plano': optional(z.number().int()),
  usuario: z.string(),
  'dt-hr-import': isoDateTimeSchema,
  linhas: z.array(linhaImportSchema),
  validas: z.number().int().nonnegative(),
  erros: z.number().int().nonnegative(),
});
export type LoteImport = z.infer<typeof loteImportSchema>;

export const templateImportSchema = z.object({
  colunas: z.array(
    z.object({
      nome: z.string(),
      obrigatorio: z.boolean(),
      exemplo: z.string(),
      descricao: z.string(),
    }),
  ),
});
export type TemplateImport = z.infer<typeof templateImportSchema>;

/** `POST /imports`: cada linha da planilha convertida em texto `;`; a primeira é o cabeçalho. */
export const importNovoSchema = z.object({
  'tipo-import': tipoImportSchema,
  'nome-arquivo': z.string().min(1),
  'nr-plano': z.number().int().optional(),
  linhas: z.array(z.string()).min(2, 'A planilha precisa de cabeçalho e ao menos uma linha'),
});
export type ImportNovo = z.infer<typeof importNovoSchema>;

export const resultadoAplicarSchema = z.object({
  aplicadas: z.number().int().nonnegative(),
  inseridas: z.number().int().nonnegative(),
  atualizadas: z.number().int().nonnegative(),
});
export type ResultadoAplicar = z.infer<typeof resultadoAplicarSchema>;

export const importQuerySchema = z.object({
  'tipo-import': tipoImportSchema.optional(),
  page: z.coerce.number().int().positive().default(1),
});
export type ImportQuery = z.infer<typeof importQuerySchema>;
